import LocationMap from "@/components/Common/LocationMap/LocationMap.vue";
import OptionListDialog from "@/components/Common/OptionListDialog/OptionListDialog.vue";
import axios from "axios";
import { getTokenHeader } from "@/helpers/commonHelper";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import "./LocationsEditDialog.scss";
import TreeViewSelection from "@/components/Common/TreeViewSelection/TreeViewSelection.vue";

export default {
  name: "LocationsEditDialog",
  components: {
    TreeViewSelection,
    LocationMap,
    OptionListDialog
  },
  data: () => ({
    countryArray: [
      { code: "de", label: "Deutschland" },
      { code: "at", label: "Österreich" },
      { code: "ch", label: "Schweiz" },
      { code: "fr", label: "Frankreich" },
      { code: "nl", label: "Niederlande" },
      { code: "be", label: "Belgien" },
      { code: "lu", label: "Luxemburg" },
      { code: "cz", label: "Tschechische Republik" },
      { code: "pl", label: "Polen" },
      { code: "dk", label: "Dänemark" }
    ],
    weightArray: [
      { weight: 10, label: "Ortsteile, Stadtbezirke, u.ä." },
      { weight: 20, label: "Siedlung" },
      { weight: 40, label: "Dorf" },
      { weight: 50, label: "Gemeindezentrum o. großes Dorf" },
      { weight: 70, label: "Markt" },
      { weight: 80, label: "Oberzentrum" },
      { weight: 90, label: "Großstadt" },
      { weight: 100, label: "Metropole" },
      { weight: 250, label: "Ort kommt immer als erstes" }
    ],
    radiusArray: [
      { value: 0, label: "Standard" },
      { value: 2, label: "2" },
      { value: 10, label: "10" },
      { value: 25, label: "25" },
      { value: 50, label: "50" },
      { value: 100, label: "100" },
      { value: 250, label: "250" }
    ],
    debugJson: false,
    unsaved: "",
    searchPostcodes: "",
    searchPositionText: "",
    loading: true,
    isRequired: [v => !!v || "Feld bitte ausfüllen"],
    districtItems: [],
    stateItems: [],
    districtLoading: false,
    stateLoading: false,
    searchDistrict: null,
    searchState: null,
    geoPositionAccept: false,
    mainPeacock: "#00636C",
    mainRed: "#c55c52"
  }),
  props: ["editedItem", "dialog", "config", "featureGroups"],
  event: ["afterSave", "createError"],
  computed: {
    formTitle() {
      return this.editedItem.isNew
        ? "Ortseintrag anlegen"
        : "Ortseintrag bearbeiten";
    },
    principalRadius() {
      let radius = this.radiusArray[0].value; //standard radius
      this.editedItem.radius.forEach(r => {
        if (r.principal === this.currentPrincipal) {
          radius = r.radius;
        }
      });
      return radius;
    },
    principals() {
      return this.$store.state.principals ?? [{}];
    },
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    },
    isAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:admin");
    }
  },
  watch: {
    dialog(d) {
      //dialog open
      if (d) {
        this.initAutocomplete();
        this.unsaved = JSON.stringify(this.editedItem);
      }
    },
    async searchDistrict(word) {
      if (!word) {
        return;
      }
      const params = {
        apiKey: this.config.apiKey,
        q: word
      };
      try {
        const result = await axios.get(
          `${env.locations_api_client_url}search/district`,
          {
            params
          }
        );
        this.districtItems = result.data;
      } catch (err) {
        this.$emit("createError", err);
      }

      //tell vue array changes
      this.districtItems.reverse().reverse();
    },
    async searchState(word) {
      if (!word) {
        return;
      }
      const params = {
        apiKey: this.config.apiKey,
        q: word
      };
      try {
        const result = await axios.get(
          `${env.locations_api_client_url}search/state`,
          {
            params
          }
        );
        this.stateItems = result.data;
      } catch (err) {
        this.$emit("createError", err);
      }

      //tell vue array changes
      this.stateItems.reverse().reverse();
    }
  },
  methods: {
    initAutocomplete() {
      //fix autocomplete fields
      if (this.editedItem.state) {
        this.stateItems = [];
        this.stateItems.push(this.editedItem.state);
      }
      if (this.editedItem.district) {
        this.districtItems = [];
        this.districtItems.push(this.editedItem.district);
      }
    },
    updatePosition(pos) {
      // vue watches only specific array change methods
      this.editedItem.geo.coordinates = [];
      this.editedItem.geo.coordinates.push(pos.lng, pos.lat);
    },
    async updateAddress(pos) {
      const hint = await this.getGeoHint(pos.lon, pos.lat); // osm-lng == lon

      // if field-value empty -> insert hint-value.
      this.editedItem.country = this.editedItem.country ?? hint.country ?? "";
      this.editedItem.country_code =
        this.editedItem.country_code ?? hint.country_code ?? "";
      this.editedItem.postcodes = this.editedItem.postcodes.length
        ? this.editedItem.postcodes
        : hint.post_code ?? [];
      this.editedItem.district =
        this.editedItem.district ?? hint.district ?? "";
      this.editedItem.state = this.editedItem.state ?? hint.state ?? "";
      //fix autocomplete fields
      this.initAutocomplete();

      // fill belongs_to if found location-name is different
      if (
        hint.title.toLowerCase().trim() !==
          this.editedItem.title.toLowerCase().trim() &&
        !this.editedItem.belongs_to
      ) {
        this.editedItem.belongs_to = hint.title ?? "";
      }
    },
    async getGeoHint(lng, lat) {
      const headers = getTokenHeader();
      if (headers) {
        try {
          const result = await axios.get(
            `${env.locations_api_client_url}location/hint_geo/?lat=${lat}&lng=${lng}`,
            {
              headers
            }
          );
          return result.data;
        } catch (err) {
          this.$emit("createError", err);
        }
      }
    },
    updateRadiusForPrincipal(radiusKm) {
      const radiusArray = [];
      let updated = false;
      this.editedItem.radius.forEach(r => {
        if (r.principal === this.currentPrincipal) {
          r.radius = radiusKm;
          updated = true;
        }
        radiusArray.push(r);
      });
      if (!updated) {
        radiusArray.push({
          principal: this.currentPrincipal,
          radius: radiusKm
        });
      }
      this.editedItem.radius = radiusArray;
      //let vue know changes
      this.editedItem.radius.push({});
      this.editedItem.radius.pop();
    },
    async searchPosition() {
      let that = this;
      const table = {
        header: ["Name", "Breitengrad", "Längengrad"],
        content: ["display_name", "lat", "lon"],
        key: "osm_id"
      };
      try {
        const positions = await this.osmLocation(this.searchPositionText);
        that.$refs.optionDialog.showDialog(positions.data, table);
      } catch (err) {
        this.$emit("createError", err);
      }
    },
    osmLocation(address) {
      const url =
        "https://nominatim.openstreetmap.org/search?format=json&limit=5&accept-language=de,en&q=";
      return axios.get(url + address);
    },
    getPositionFromAddress() {
      const { title, belongs_to, district, state, country } = this.editedItem;
      let address = title;
      if (belongs_to) address += `, ${belongs_to}`;
      if (district) address += `, ${district}`;
      if (state) address += `, ${state}`;
      if (country) address += `, ${country}`;

      this.findLocation(address);
    },
    async findLocation(search) {
      const table = {
        header: ["Name", "Breitengrad", "Längengrad"],
        content: ["display_name", "lat", "lon"],
        key: "osm_id"
      };

      try {
        const result = await this.osmLocation(search);
        this.$refs.geoAdressDialog.showDialog(result.data, table);
      } catch (err) {
        console.error({
          message: "osmLocation-fail",
          error: err,
          search: search
        });
      }
    },
    updateCountryCode() {
      this.countryArray.forEach(c => {
        if (c.label === this.editedItem.country) {
          this.editedItem.country_code = c.code;
        }
      });
    },
    // change location type if there is an entry in belongs_to
    setWeightIfSublocation() {
      if (this.editedItem.belongs_to) {
        this.editedItem.weight = 10;
      }
    },
    close() {
      const before = this.unsaved;
      const current = JSON.stringify(this.editedItem);
      if (before === current) {
        this.$emit("close");
      } else {
        this.$confirm(
          `Wollen Sie wirklich Abbrechen? Alle Änderungen werden verworfen!`,
          confirmWarningConfig
        ).then(res => {
          if (res) {
            this.$emit("close");
          }
        });
      }
    },
    async save(close) {
      if (this.$refs.editForm.validate()) {
        let success = false;
        try {
          success = this.editedItem.isNew
            ? await this.createLocation()
            : await this.updateLocation();
          if (success) {
            this.unsaved = JSON.stringify(this.editedItem);
            this.$emit("afterSave", close);
          }
        } catch (ex) {
          this.$emit("createError", ex);
        }
      } else {
        this.snackMessage(
          "Nicht gespeichert! Bitte alle Pflichtfelder überprüfen!",
          this.mainRed
        );
      }
    },
    snackMessage(...emitArgs) {
      //emit parent snackbar - child-snackbar seems unreliable
      this.$emit("snackMessage", ...emitArgs);
    },
    async updateLocation() {
      const headers = getTokenHeader(),
        res = await axios.put(
          `${env.locations_api_client_url}location`,
          this.editedItem,
          { headers }
        );
      return res.status === 200;
    },
    async createLocation() {
      const headers = getTokenHeader(),
        res = await axios.post(
          `${env.locations_api_client_url}location`,
          this.editedItem,
          { headers }
        );
      //called by copyToPrincipal
      if (this.editedItem.orginId) {
        await this.disconnectOrgin(
          this.editedItem.orginId,
          this.currentPrincipal
        );
      }
      return res.status === 200;
    },
    //removes principal from orgin-location
    async disconnectOrgin(orginId, principal) {
      const headers = getTokenHeader(),
        res = await axios.delete(
          `${env.locations_api_client_url}location/${orginId}/${principal}`,
          { headers }
        );
      return res.status === 200;
    }
  }
};
